// extracted by mini-css-extract-plugin
module.exports = {"ProductHeader":"ProductHeader_ProductHeader__TAcMq"};